import useAccountQuery from 'api/queries/useAccountQuery';

import PlusMembershipOptInPill from './PlusMembershipOptInPill';
import { usePlusMembershipOptInPill } from './usePlusMembershipOptInPill';

/**
 * Native-app-only M+ opt-in pill. Keeps `usePlusMembershipOptInPill` off the React tree on web;
 * mount only when `window.isNativeApp` (see `ShopLayout`).
 *
 * @returns {JSX.Element | null}
 */
function NativePlusMembershipOptInPill() {
    const { data: account = {} } = useAccountQuery();
    const {
        dismissPlusMembershipOptInPill,
        plusMembershipOptInPillMessage,
        plusMembershipOptInPillMessageVariant,
        showPlusMembershipOptInPill,
    } = usePlusMembershipOptInPill();

    if (!account?.marketplaceOpen || !showPlusMembershipOptInPill) {
        return null;
    }

    return (
        <PlusMembershipOptInPill
            layout="native"
            message={plusMembershipOptInPillMessage}
            messageVariant={plusMembershipOptInPillMessageVariant}
            onDismiss={dismissPlusMembershipOptInPill}
        />
    );
}

export default NativePlusMembershipOptInPill;
